import { forwardRef } from 'react'
import { Alert as MuiAlert, type AlertProps as MuiAlertProps } from '@mui/material'

export type AlertProps = MuiAlertProps

export const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert ref={ref} {...props} />
})
